export default __webpack_public_path__ + "static/media/frown-o.96b3955e.svg";